var ko = require('knockout'),
  cart = require('_components/organisms/shopping-cart/shopping-cart-storage'),
  APIHelper = require('_js/APIHelper'),
  analytics = require('_js/analytics-ecommerce');

function getAvailability(availability) {
  if (!availability) return '';

  switch (availability.Status) {
    case 1:
      return 'open';
    case 2:
      return 'few';
    case 3:
      return 'full';
    case 4:
      return 'cancelled';
  }
}

function GetCourseType(courseType) {
  switch (courseType) {
    case 2:
      return 'icon-fagdag';
    case 3:
    case 8:
      return 'icon-screen';
    case 4:
      return 'icon-fagdag';
    case 5:
      return 'icon-bundle';
    default:
      return 'icon-globe'; //Utenlandskurs
  }
}

function GetTruncateCssClasses(authorizationCredits, filterAuthorizationType) {
  if (authorizationCredits == null || authorizationCredits.length == 0) {
    return 'truncate market-tile';
  }
  var filteredCredits = filterCredits(
    authorizationCredits,
    filterAuthorizationType
  );
  if (filteredCredits === undefined || filteredCredits.length == 0) {
    return 'truncate market-tile';
  }
  if (filteredCredits.length > 3) {
    return (
      'truncate market-tile short-' + filteredCredits.length + ' is-truncated'
    );
  }
  return 'truncate market-tile normal is-truncated';
}

function filterCredits(credits, filterAuthorizationType) {
  return credits.filter(function(x) {
    return x.AuthorizationType == filterAuthorizationType;
  });
}

function MediaListModel(params) {
  var self = this;
  self.item = params.item;
  self.quickPurchaseOnlineCourse = params.quickPurchaseOnlineCourse;
  self.showCart = self.item.ShowCart;
  self.videoId = params.item.VideoId;
  self.userHasPurchasedCourseUrl = self.item.UserHasPurchasedCourseUrl;
  //This is a temporary way to show image
  self.image = 'url(' + self.item.ImageUrl + ')';
  self.item._IsPurchasedLocal = ko.observable(false);
  self.item.IsPurchased = ko.computed({
    read: function () {
      var inCart = !!cart.findCourseInCart(cart.getCart(), self.item.Id);
      var apiPurchased = !!self.item._IsPurchasedLocal();
      return inCart || apiPurchased;
    },
    write: function (value) {
      self.item._IsPurchasedLocal(value);
    }
  });


  self.isAddedToMyCourses = ko.observable(false);
  self.courseId = null;
  self.loading = ko.observable(true);
  //Dynamic CSS classes
  self.availability = getAvailability(self.item.Availability);
  self.availabilityText = self.item.AvailabilityText;
  self.eventTypeIconString = GetCourseType(self.item.EventType);
  self.authorizationCredits = self.item.AuthorizationCredits;
  self.filterAuthorizationType = ko
    .observable('1')
    .subscribeTo('filterAuthorizationTypeUpdated', true);
  self.truncate = GetTruncateCssClasses(self.item.AuthorizationCredits, '1');
  self.addToCart = function(el, ev) {
    ev.preventDefault();

    self.courseId = self.item.Id;
    cart.addCourseToCart(self.item);
    self.item._IsPurchasedLocal(true);
  };

  self.trackAndRedirect = function() {
    analytics.productClickedFromCatalog(self.item);
  };

  self.trackAndRedirectMousedown = function(data, event) {
    if (event.which === 2) {
      analytics.productMouseDownEvent(self.item);
      window.open(data.Url, '_blank');
      return;
    }
    if (event.which === 3) {
      analytics.productMouseDownEvent(self.item);
    }
  };
  var isRNFriProduct = self.item.IsRNFriProduct;
  var netCourse = self.item.EventType === 3;
  var onsiteCourse = self.item.EventType === 1;
  var showRNFriButton =
    (isRNFriProduct && netCourse) ||
    (isRNFriProduct && (onsiteCourse && self.item.FreeOfChargeWithRnFri));
  self.item.IsRNFriProduct = showRNFriButton;

  // Lytt til changes på handlekurven. Hvis element er fjernet som matcher denne IDen
  ko.postbox.subscribe('removeCourse', function (course) {
    if (course.Id === self.item.Id) {
      self.item._IsPurchasedLocal(false);
    }
  });

  this.userHasPurchasedCourse();
}

MediaListModel.prototype.userHasPurchasedCourse = function () {
  var userHasPurchasedCourseUrl = this.userHasPurchasedCourseUrl;
  if (
    userHasPurchasedCourseUrl === null ||
    userHasPurchasedCourseUrl === undefined ||
    userHasPurchasedCourseUrl === ''
  ) {
    this.loading(false);
    return;
  }

  var url = userHasPurchasedCourseUrl + '?sequenceId=' + this.item.Key;

  APIHelper.get(
    url,
    function (response) {
      this.item._IsPurchasedLocal(response);
      this.loading(false);
    }.bind(this),
    function(response) {
      var location = window.location.href || document.URL;
      this.loading(false);

      APIHelper.post('/api/log/error', {
        message: 'API-error: calculator.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }.bind(this)
  );
};

module.exports = MediaListModel;
